import {DocumentType} from "../../util/constants";

export interface IDocumentState {
    fetchLoading: boolean
    item: IDocument
    items: IDocument[]
    actionLoading: boolean
    fetchHistoryLoading: boolean
    documentHistory: IDocument[]
}

export interface IDocument {
    id: string
    created_at: string
    name: DocumentType
    content_en: string
    content_mk: string
    content_al: string
    additional_information: any | null

    [key: string]: any
}

export const initialDocumentState: IDocument = {
    id: '',
    created_at: '',
    name: DocumentType.PRIVACY,
    content_en: '',
    content_mk: '',
    content_al: '',
    additional_information: null,
}

export interface IPerson {
    image_url: string
    name_en: string
    name_mk: string
    name_al: string
    position_en: string
    position_mk: string
    position_al: string
    description_en: string
    description_mk: string
    description_al: string
    quote_en: string
    quote_mk: string
    quote_al: string

    [key: string]: any
}

export const initialPersonState: IPerson = {
    description_al: "",
    description_en: "",
    description_mk: "",
    image_url: "",
    name_al: "",
    name_en: "",
    name_mk: "",
    position_al: "",
    position_en: "",
    position_mk: "",
    quote_al: "",
    quote_en: "",
    quote_mk: ""
}